export default "__VITE_ASSET__DnxtDTTy__"